import axios from "@/api/axiosAuthRequired.js"
import { getAuthHeaders } from "@/api/auth"
import { BASE_URL } from "@/constants/util"
const PROGUIDES_WEB_URL = process.env.PROGUIDES_WEB_URL

export const fetchBootcampByKey = async key => {
  try {
    const url = `${PROGUIDES_WEB_URL}api/v2/bootcamps/by-key/${key}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const getActiveBootcampsProgress = async () => {
  try {
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/courses`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return null
  }
}

export const logModuleAttempt = async moduleId => {
  try {
    const config = {
      headers: getAuthHeaders(),
    }
    const body = {
      content_type: "segment",
      content_id: moduleId,
      status: true,
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/attempt`
    await axios.post(url, body, config)
  } catch (error) {
    console.error(error)
  }
}

export const logModuleCompletion = async moduleId => {
  try {
    const config = {
      headers: getAuthHeaders(),
    }
    const body = {
      content_type: "segment",
      content_id: moduleId,
    }
    const url = `${PROGUIDES_WEB_URL}api/v2/user/content-progression/complete`
    await axios.post(url, body, config)
  } catch (error) {
    if (error.response.status === 403) {
      console.log(error.response.data.message)
    } else {
      console.error(error)
    }
  }
}

export const fetchBootcampTasksByKey = async key => {
  try {
    const url = `${PROGUIDES_WEB_URL}api/v2/user/bootcamps/${key}/tasks`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
  }
}

export const fetchEnrolledBootcampsByGameKey = async key => {
  try {
    const url = `${BASE_URL}user/bootcamps/enrolled?game=${key}`
    const config = {
      headers: getAuthHeaders(),
    }
    const res = await axios.get(url, config)
    return res.data
  } catch (error) {
    console.error(error)
    return []
  }
}



// WEBPACK FOOTER //
// ./src/store/bootcamp/bootcamp.apis.js